module.exports = __webpack_public_path__ + "img/bed-1.d75fbdf8.svg";